import { CdnConfigurationImpl } from "../data/CdnConfigurationImpl";
import { ICdnConfigurationRepository } from "../domain/repositories/ICdnConfigurationRepository";
import { CdnConfigurationUseCase } from "../domain/useCases/CdnConfigurationUseCase";
import { CdnConfigurationViewModel } from "../presentation/viewModel/CdnConfigurationViewModel";
import { InjectionBinding, InjectionModule } from "app/di/DependencyInjections";

export class CdnConfigInjection extends InjectionModule {
  private static readonly cdnConfigurationRepositoryToken = Symbol(
    "ICdnConfigurationRepository",
  );
  private static readonly cdnConfigurationUseCaseToken = Symbol(
    "CdnConfigurationUseCase",
  );
  private static readonly cdnConfigurationViewModelToken = Symbol(
    "CdnConfigurationViewModel",
  );

  protected static override bindings: InjectionBinding[] = [
    {
      scope: "otherRepo",
      token: this.cdnConfigurationRepositoryToken,
      useClass: CdnConfigurationImpl,
    },
    {
      scope: "otherRepo",
      token: this.cdnConfigurationUseCaseToken,
      useClass: CdnConfigurationUseCase,
    },
    {
      scope: "viewModel",
      token: this.cdnConfigurationViewModelToken,
      useClass: CdnConfigurationViewModel,
    },
  ];

  static getRepo(): ICdnConfigurationRepository {
    return this.resolve(this.cdnConfigurationRepositoryToken);
  }

  static getUseCase(): CdnConfigurationUseCase {
    return this.resolve(this.cdnConfigurationUseCaseToken);
  }
}
